import React from 'react'

function NameFormatter({user}) {
  const firstName = user?.firstName
  const lastName = user?.lastName

  const fullName = lastName ? `${firstName} ${lastName}` : firstName;

  return <span>{fullName}</span>;

}

export default NameFormatter